import { memo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLongPress } from 'use-long-press';

import DimesionPage from 'pages/PlanRevamp/Inputs/DimensionPage';
import IndicatorPageMultiDim from 'pages/PlanRevamp/Inputs/IndicatorPageMultiDim';
import { getSelectedDriver } from 'redux/PlanPageSlice';

import { usePlanPageUiRevamp } from '../usePlanPageUiRevamp';

import RevampInputEmptyState from './RevampInputEmptyState';
import RevampOrganisationPanel from './RevampOrganisationPanel';

interface Properties {
  refetchRequest: () => void;
}

/**
 * Revamp inputs shell — only organisation (org chart + table) uses new UI.
 * Indicator and property drivers keep legacy panels.
 */
const RevampInputSection = ({ refetchRequest }: Properties) => {
  const isRevampEnabled = usePlanPageUiRevamp();
  const [isLongClicked, setIsLongClicked] = useState(false);
  const currentDriver = useSelector(getSelectedDriver);

  const longClickCheck = useLongPress(() => {
    setIsLongClicked((previousState) => !previousState);
  });

  if (!isRevampEnabled) {
    return null;
  }

  const onDataChange = () => refetchRequest();

  if (currentDriver?.type === 'dimension') {
    return (
      <RevampOrganisationPanel
        longClickCheck={longClickCheck}
        isLongClicked={isLongClicked}
        refetchRequest={refetchRequest}
      />
    );
  }

  if (currentDriver?.type === 'indicator') {
    return <IndicatorPageMultiDim refetchRequest={onDataChange} />;
  }

  if (currentDriver?.type === 'property') {
    return <DimesionPage refetchRequest={onDataChange} />;
  }

  return <RevampInputEmptyState />;
};

export default memo(RevampInputSection);
